module.exports = __webpack_public_path__ + "img/Richtung.d19d8402.svg";